import { FvLinkButton, Icon } from '@fv/client-components'
import type { FullShipment } from '@fv/client-types'

import { apiUri } from '@/constants'
import { ShipperOnly } from '@/features/auth/HasRole'
import { useArchiveLoads } from '@/hooks/shipments'
import { useRepeatShipment } from '@/hooks/shipments/useRepeatShipment'

import { DividedContent } from '../DividedContent'
import { FooterBar } from '../FooterBar'

type Props = { load: FullShipment }

export const Footer = ({ load }: Props) => {
  const { isArchived, loadId, status } = load
  const { archive, canArchive, isArchiving } = useArchiveLoads(status)
  const repeat = useRepeatShipment(load)

  return (
    <FooterBar jc className="col-span-full">
      <DividedContent theme="blue">
        <ShipperOnly permissions={['load-creator']}>
          <FvLinkButton icon="clone" onClick={repeat}>
            Repeat shipment
          </FvLinkButton>
        </ShipperOnly>

        {canArchive && (
          <ShipperOnly permissions={['load-booker']}>
            <FvLinkButton
              icon={isArchiving ? 'spinner' : 'archive'}
              onClick={() => {
                archive({
                  loadIds: [loadId],
                  shouldArchive: !isArchived,
                })
              }}
            >
              {isArchived ? 'Unarchive' : 'Archive'} shipment
            </FvLinkButton>
          </ShipperOnly>
        )}
        {load.carrierTracking && (
          <a
            href={`${apiUri}/shipments/${loadId}/track/carrier`}
            rel="noreferrer"
            target="_blank"
          >
            <Icon icon="square-arrow-up-right" />
            <span>External tracking</span>
          </a>
        )}
      </DividedContent>
    </FooterBar>
  )
}
